<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="sharedNetworks"
      :items="sharedNetworks"
      :fields="sharedNetworksFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal
      :editItem="selectedSharedNetworks"
      :isEdit="isEdit"
      :sharedNetworks="sharedNetworks"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      selectedSharedNetworks: {
        relay: {'ip-addresses': []}
      },
      isEdit: false,
      sharedNetworksFields: [
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'valid-lifetime', label: this.$i18n.t('Valid lifetime'), sortable: true},
        {key: 'interface', label: this.$i18n.t('Interface'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedSharedNetworks = {
        name: '',
        'valid-lifetime': 4000,
        interface: '',
        relay: {
          'ip-addresses': [],
          ip_addresses: []
        },
        'option-data': [],
        subnet6: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditSharedNetworks', '#btnShow')
    },
    editItem (item) {
      this.isEdit = true
      this.selectedSharedNetworks = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditSharedNetworks', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Shared network"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let del = JSON.parse(JSON.stringify(this.sharedNetworks))
      del = del.filter((value) => {
        return value.num !== item.num
      })
      for (let el of del) {
        delete el.num
        for (let elOptionData of el['option-data']) {
          delete elOptionData.numOptionData
        }
      }
      let DHCP = {
        'is_test_only': false,
        'loop_count_timeout': 35,
        'config': {}
      }
      DHCP.config = copy.arguments
      DHCP.config.Dhcp6['shared-networks'] = del
      let response = this.$store.dispatch('Settings/SAVE_DHCPV6', DHCP)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    sharedNetworks () {
      let numPools = 0
      let numOptionData = 0
      let numAdress = 0
      let numSharedNetworks = 0
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let sharedNetworks = copy.arguments.Dhcp6['shared-networks']
      for (let el of sharedNetworks) {
        el.num = ++numSharedNetworks
        el.relay.ip_addresses = []
        for (let elAdress of el.relay['ip-addresses']) {
          let newEl = {
            num: 0,
            adress: ''
          }
          newEl.num = ++numAdress
          newEl.adress = elAdress
          el.relay.ip_addresses.push(newEl)
        }
        for (let elOptionData of el['option-data']) {
          if (!elOptionData.name) {
            elOptionData.name = ''
          }
          elOptionData.numOptionData = ++numOptionData
        }
        for (let elSubnet of el.subnet6) {
          for (let elPools of elSubnet.pools) {
            elPools.numPools = ++numPools
          }
          for (let elOptionData of elSubnet['option-data']) {
            elOptionData.numOptionData = ++numOptionData
          }
        }
      }
      return sharedNetworks
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DHCPV6')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/DHCPv6/sharedNetworks/main.vue